/**
 * @param {number} estimatedAverageInterest
 * @returns {number}
 */
function calculateEstimatedMonthlyCost ({ estimatedAverageInterest = 0 } = {}) {
  return ((Math.pow((estimatedAverageInterest + 1), (1 / 12)) - 1) * 12) / 12
}

module.exports = { calculateEstimatedMonthlyCost }
